import actionTypes from "../constants/actionTypes";

const initialState = {
    youtubeData: {},
    isYoutube: {}
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.YOUTUBE_ON_RESULT:
            return {
                ...state,
                youtubeData: {
                    ...state.youtubeData,
                    [action.youtubeListId]: action.youtubeData
                },
                isYoutube: {
                    ...state.isYoutube,
                    [action.youtubeListId]: true
                }
            };
        default:
            return state;
    }
}
